import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../../../ui/dialog";
import { EDSButton } from "../../../../eds/EDSButton";

interface UnlinkBookingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isUnlinking: boolean;
  bookingReference?: string;
}

const UnlinkBookingDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isUnlinking,
  bookingReference
}: UnlinkBookingDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        aria-describedby="unlink-booking-dialog-description"
        className="bg-[var(--panelBackground)] shadow-[0_3px_16px_0_rgba(0,0,0,0.16)] max-w-[400px] w-[90%]"
      >
        <DialogHeader>
          <DialogTitle>Unlink booking</DialogTitle>
          <DialogDescription id="unlink-booking-dialog-description">
            Are you sure you want to unlink{" "}
            {bookingReference ? (
              <strong>DMN-{bookingReference}</strong>
            ) : (
              "this booking"
            )}{" "}
            from the group?
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <EDSButton
            variant="outline"
            size="md"
            onClick={() => onOpenChange(false)}
            disabled={isUnlinking}
          >
            Cancel
          </EDSButton>
          <EDSButton
            variant="destructive"
            size="md"
            onClick={onConfirm}
            disabled={isUnlinking}
            aria-busy={isUnlinking}
          >
            {isUnlinking ? "Unlinking…" : "Unlink"}
          </EDSButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnlinkBookingDialog;
